import { useRouteContext } from "@tanstack/react-router";
import type { EnvironmentInfo } from "#/modules/util.environment/env.server";

/**
 * Current environment info (client). Read from the root route context, where `getRouteContext`
 * resolves it server-side — available synchronously from the first render (portal parity: RR7
 * read it from the root loader).
 */
export function useEnvironment(): EnvironmentInfo {
  return useRouteContext({ from: "__root__", select: (ctx) => ctx.environment });
}
